var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.09277 9.90421H20.9167",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80811 13.8096C6.80811 13.3954 7.14389 13.0596 7.55811 13.0596H7.56737C7.98158 13.0596 8.31737 13.3954 8.31737 13.8096C8.31737 14.2238 7.98158 14.5596 7.56737 14.5596H7.55811C7.14389 14.5596 6.80811 14.2238 6.80811 13.8096ZM12.005 13.0597C11.5907 13.0597 11.255 13.3955 11.255 13.8097C11.255 14.2239 11.5907 14.5597 12.005 14.5597H12.0142C12.4284 14.5597 12.7642 14.2239 12.7642 13.8097C12.7642 13.3955 12.4284 13.0597 12.0142 13.0597H12.005ZM16.4425 13.0597C16.0282 13.0597 15.6925 13.3955 15.6925 13.8097C15.6925 14.2239 16.0282 14.5597 16.4425 14.5597H16.4517C16.8659 14.5597 17.2017 14.2239 17.2017 13.8097C17.2017 13.3955 16.8659 13.0597 16.4517 13.0597H16.4425ZM16.4425 16.946C16.0282 16.946 15.6925 17.2817 15.6925 17.696C15.6925 18.1102 16.0282 18.446 16.4425 18.446H16.4517C16.8659 18.446 17.2017 18.1102 17.2017 17.696C17.2017 17.2817 16.8659 16.946 16.4517 16.946H16.4425ZM11.255 17.696C11.255 17.2817 11.5907 16.946 12.005 16.946H12.0142C12.4284 16.946 12.7642 17.2817 12.7642 17.696C12.7642 18.1102 12.4284 18.446 12.0142 18.446H12.005C11.5907 18.446 11.255 18.1102 11.255 17.696ZM7.55811 16.946C7.14389 16.946 6.80811 17.2818 6.80811 17.696C6.80811 18.1103 7.14389 18.446 7.55811 18.446H7.56737C7.98158 18.446 8.31737 18.1103 8.31737 17.696C8.31737 17.2818 7.98158 16.946 7.56737 16.946H7.55811Z",
    fill: "#200E32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0438 2.5V5.79078",
    stroke: "#6E6F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96564 2.5V5.79078",
    stroke: "#6E6F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2383 4.07919H7.77096C4.83427 4.07919 3 5.71513 3 8.72222V17.7719C3 20.8262 4.83427 22.5 7.77096 22.5H16.229C19.175 22.5 21 20.8546 21 17.8475V8.72222C21.0092 5.71513 19.1842 4.07919 16.2383 4.07919Z",
    stroke: "#6E6F7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar1);
export default __webpack_public_path__ + "static/media/calendar-1.66a81cc73ea951cb51430cddb37decac.svg";
export { ForwardRef as ReactComponent };